export class FollowUpModel {
  id_followup: number;
  descricao: string;
  valor: string;
  opcao: string = null;
  vencimento: string;
  emails: string;
}



// WEBPACK FOOTER //
// ./src/app/follow-up/follow-up.model.ts